import { HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

import { ForcePasswordChangeService } from 'src/app/services/auth/force-password-change.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService {

  constructor(
    private cookieService: CookieService,
    private router: Router,
    private forcePasswordChangeService: ForcePasswordChangeService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.cookieService.get('gr_access');
    let request = req;

    if (token) {
      request = req.clone({
        setHeaders: {
          authorization: `Bearer ${token}`,
        }
      });
    } else {
      request = req.clone({
        setHeaders: {
          'x-client-platform': environment.clientPlatform
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          localStorage.removeItem('brandlogo');
          this.cookieService.delete('gr_access', '/');
          this.cookieService.delete('gr_refresh', '/');
          this.router.navigate(['/']);
        } else if (error.status === 403 && error.error?.code === 'must_change_password') {
          this.forcePasswordChangeService.open();
        }
        return throwError(() => error);
      })
    );
  }
}
